import { Component, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { Langue } from 'src/app/shared/models/iContact/global/langue';
import { TemplateViewModalComponent } from 'src/app/components/modals/template-view-modal/template-view-modal.component';
import { Mail } from 'src/app/shared/models/mails/mail';
import { DocumentTemplatePagedResult } from 'src/app/shared/models/iCourrier/document-template-paged-result';
import { ServicesService } from 'src/app/shared/services/services.service';
import { DropdownService } from 'src/app/shared/interfaces';
import { LanguagesService } from 'src/app/shared/services/languages.service';
import { MeService } from 'src/app/shared/services/me.service';
import { DocumentTemplate } from 'src/app/shared/models/iCourrier/document-template';
import { catchError, forkJoin, of } from 'rxjs';
import { Cols } from 'src/app/shared/models';

@Component({
  selector: 'app-courrier-create-template-choice',
  templateUrl: './courrier-create-template-choice.component.html',
  styleUrls: ['./courrier-create-template-choice.component.scss'],
  providers: [DialogService],
})
export class CourrierCreateTemplateChoiceComponent {
  @ViewChild('previewModal') previewModal: ElementRef;
  @Input() mailMode: string;
  @Input() set courrier(value) {
  if (value) {
    this.activeMail = value;
    this.serviceId = value.serviceProprietaireId;
    this.currentPage = 1;
    this.currentPageSize = 20;
    this.getTemplateList(value.serviceProprietaireId);
  }
}

  @Output() public selectedValue: EventEmitter<DocumentTemplate> = new EventEmitter();
  public templates: DocumentTemplate[] = [];
  public selectedTemplate: DocumentTemplate;
  public languages: Langue[];
  public services: DropdownService[] = [];
  public activeMail: Mail;
  public documentTemplatePagedResult: DocumentTemplatePagedResult;
  public serviceId: number;
  public columns: Cols[] = [];
  public isLoaded = false;

  public first = 1;
  public currentPage = 1
  public currentPageSize = 20;

  constructor(
    private meService: MeService,
    private dialogService: DialogService,
    private servicesService: ServicesService,
    private langsService: LanguagesService
  ) {}

  public getTemplateList(serviceID: number, pageNumber = 1, pageSize = 20): void {
  const dataToSend = {
    svcId: serviceID,
    pageSize: pageSize,
    pageNumber: pageNumber,
    type: null,
  };
    if (pageNumber) {
      dataToSend.pageNumber = pageNumber;
    }

    if (this.mailMode === 'emailmodel' || this.mailMode === 'emailnomodel') {
      dataToSend.type = 'CourrierEmail';
    } else {
      dataToSend.type = 'Courrier';
    }
    this.meService.getMyTemplates(dataToSend).subscribe({
      next: (response) => {
        this.templates = response.items.map((x) => new DocumentTemplate(x));
        this.documentTemplatePagedResult = response;
        this.getData();
      },
      error: (error) => {
        console.error('Error : ', error);
      },
    });
  }

  lazyLoadData(event): void {
  const pageNumber = Math.floor(event.first / event.rows) + 1;
  const pageSize = event.rows;

  if (pageNumber !== this.currentPage || pageSize !== this.currentPageSize) {
    this.currentPage = pageNumber;
    this.currentPageSize = pageSize;
    this.getTemplateList(this.serviceId, pageNumber, pageSize);
  }
}

  public getData(): void {
    forkJoin({
      services: this.servicesService.fetchMappedServicesToPrimeNGDropdowns().pipe(
        catchError(() => {
          console.error(`Erreur lors de la récupération des services`);
          return of(null);
        })
      ),
      langs: this.langsService.fetchMappedLanguagesToPrimeNGDropdowns().pipe(
        catchError(() => {
          console.error(`Erreur lors de la récupération des langues`);
          return of(null);
        })
      ),
    }).subscribe((value) => {
      this.services = value.services;
      this.languages = value.langs;

      this.setColumns();
      this.isLoaded = true;
    });
  }

  setColumns(): void {
    this.columns = [
      {
        field: 'description',
        header: 'Description',
        sortable: true,
        format: (value) => {
          if (value) {
            return value;
          } else {
            return '/';
          }
        },
      },
      {
        field: 'editeurSourceType',
        header: 'Source',
        sortable: true,
        format: (value) => {
          if (value) {
            return value;
          } else {
            return '/';
          }
        },
      },
      {
        field: 'serviceId',
        header: 'Service',
        sortable: true,
        format: (value) => {
          return this.services.find((service) => service.id === value)?.description ?? '/';
        },
      },
      {
        field: 'langueId',
        header: 'langue',
        sortable: true,
        format: (value) => {
          if (value) {
            return this.languages?.find((l) => l.id === value)?.description ?? '/';
          } else {
            return '/';
          }
        },
      },
      {
        field: 'hasProcedure',
        header: 'Procédure de validation',
        sortable: true,
        format: (value) => {
          return this.showBoolean(value);
        },
      },
      {
        field: 'apercu',
        header: 'Aperçu',
        sortable: true,
        format: () => {
          return `<i class="bi bi-eye-fill"></i>`;
        },
        click: (column) => {
          this.openPreviewModal(column);
        },
      },
    ];
  }

  public onTemplateSelect(e): void {
    this.selectedTemplate = this.templates.find((x) => x.id === e.id);
    this.selectedValue.emit(this.selectedTemplate);
  }

  openPreviewModal(template: DocumentTemplate): void {
    const dialog = this.dialogService.open(TemplateViewModalComponent, {
      styleClass: 'super-compos-modal-content',
      showHeader: false,
      height: '100vh',
      data: {
        template: template,
        mailId: this.activeMail.id,
      },
    });
    this.dialogService.getInstance(dialog).maximize();
  }

  private showBoolean(value: number): string {
    if (value) {
      return `✅`;
    } else if (value === -1) {
      return `⌛`;
    } else {
      return `❌`;
    }
  }
}
